import { render, staticRenderFns } from "./ToolFooter.vue?vue&type=template&id=3bdf6fed&scoped=true"
import script from "./ToolFooter.vue?vue&type=script&lang=js"
export * from "./ToolFooter.vue?vue&type=script&lang=js"
import style0 from "./ToolFooter.vue?vue&type=style&index=0&id=3bdf6fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf6fed",
  null
  
)

export default component.exports